import { Button } from '@repo/design-system-kit/components/button/button';
import { Popup } from '@repo/design-system-kit/components/popup/popup';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSegment } from '@repo/poly-hooks/segment';
import { AuthenticationFailedSvg } from '../../../svgs/authentication-failed';
import styles from './sca.module.css';

interface RefusedProps {
  onClose?: () => void;
  onConfirm: () => void;
}

export function Refused({ onClose, onConfirm }: RefusedProps): React.ReactNode {
  const segment = useSegment();
  const [isOpen, setIsOpen] = useState(true);
  const { formatMessage } = useIntl();

  useEffect(() => {
    segment.track('sca_enforcement_closed', { origin: 'authentication_failed' });
  }, [segment]);

  const handleClose = (): void => {
    onClose?.();
    setIsOpen(false);
  };
  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <Popup.Root
      aria-label={formatMessage({ id: 'sca.sensitive-actions.generic.refused.title' })}
      data-testid="sca-refused-popup"
      isOpen={isOpen}
      role="dialog"
    >
      <Popup.CloseButton onPress={handleClose} />
      <Popup.Header>
        <figure className={styles.illustrationWrap}>
          <AuthenticationFailedSvg />
        </figure>
        <Popup.Title>
          <FormattedMessage id="sca.sensitive-actions.generic.refused.title" />
        </Popup.Title>
      </Popup.Header>
      <Popup.Body>
        <p className="body-standard">
          <FormattedMessage id="sca.sensitive-actions.generic.refused.subtitle" />
        </p>
      </Popup.Body>
      <Popup.Footer>
        <Button data-testid="sca-refused-retry" onPress={handleConfirm} variant="primary">
          <FormattedMessage id="sca.sensitive-actions.generic.refused.button" />
        </Button>
      </Popup.Footer>
    </Popup.Root>
  );
}
